export type IdentifierRename = { typeIdentifier: string } | { materialIdentifier: string } | Record<string, never>;

// Grouping by material lists types as children, so the row's name is its TypeIdentifier; by type it is
// the MaterialIdentifier. Unchanged or blank sends nothing, so an untouched save never round-trips a name.
export const resolveIdentifierRename = (originalName: string, editedName: string, byType: boolean): IdentifierRename => {
  const trimmedName = editedName.trim();
  if (!trimmedName || trimmedName === originalName.trim()) return {};
  return byType ? { materialIdentifier: trimmedName } : { typeIdentifier: trimmedName };
};
